import { ButtonBase } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import Logo from '../../../icons/Logo';
import { HOME_PATH, styles } from './Header.styles';

const HeaderHomeLink = ({ size }: { size?: 'small' }) => {
  return (
    <ButtonBase
      component={RouterLink}
      to={HOME_PATH}
      aria-label='Home'
      data-testid='neobet-header-home-link'
      sx={styles.homeLink}
    >
      <Logo size={size} />
    </ButtonBase>
  );
};

export default HeaderHomeLink;
